export default {
    fund: [{
            "title": "关于基金管理机构的服务，以下表述正确的是（　　）。",
            "questions": "I．必须向投资者充分揭示投资风险<br>II．应当根据投资者的风险承担能力销售不同风险等级的基金产品<br>III．不仅要求有销售资质还应取得基金托管业务资质<br>IV．可以与基金管理人协商，而不签订书面的代销协议",
            "question": "A．I、II\nB．III、IV\nC．I、III\nD．II、III",
            "answer": "A",
            "explain": "可以从股权投资基金募集行为的合格主体有以下两类：第一类是在基金业协会办理股权投资基金管理人登记的机构，其可以自行募集其设立的股权投资基金；第二类是在中国证监会注册取得基金销售业务资格并已成为基金业协会会员的机构（基金销售机构），也可以受股权投资基金管理人的委托募集股权投资基金。但是，委托募集并不能豁免基金管理人依法应承担的责任，股权投资基金管理人委托基金销售。"
        },
        {
            "title": "股权投资基金的投资后管理的期间范围是指（　　）。",
            "question": "A．投资交割之后至项目退出之前\nB．签订投资协议之后至项目退出之前\nC．投资交割之后至项目清算之前\nD．签订投资协议之后至项目清算之前",
            "answer": "A",
            "explain": "投资后管理，是指股权投资基金与被投资企业投资交割之后，基金管理人积极参与被投资企业的管理，对被投资企业实施项目监控并提供各项增值服务的一系列活动。在投资交割之后直到项目退出之前都属于投资后管理的期间，在整个股权投资过程中持续时间最长、花费精力最多。"
        },
        {
            "title": "股权投资被称为“有耐心的资本”，主要是因为（　　）。",
            "question": "A．通常需要3-7年才能完成投资的全部流程从而实现退出\nB．股权投资基金管理对专业性要求低\nC．股权投资基金的基金份额流动性高\nD．股权投资基金的收益波动小",
            "answer": "A",
            "explain": "由于股权投资基金主要投资于未上市企业股权或上市企业的非公开交易股权，通常需要3-7年才能完成投资的全部流程从而实现退出，股权投资因此被称为“有耐心的资本”。"
        },
        {
            "title": "关于内部收益率的计算，以下说法错误的是（　　）。",
            "question": "A．一般情况下毛内部收益率大于净内部收益率\nB．内部收益率是截至某一特定时点，倒推计算至基金成立后第一笔现金流产生时，基金资金流入现值加上资产净值现值总额与资金流出现值总额相等时的折现率\nC．内部收益率是指净现值（NPV）为0时的折现率\nD．毛内部收益率通常为计算投资者出资和分配现金流的内部收益率，反映投资者投资基金的回报水平",
            "answer": "D",
            "explain": "内部收益率是指截至某一特定时点，倒推计算至基金成立后第一笔现金流产生时，基金资金流入现值加上资产净值现值总额与资金流出现值总额相等，即净现值等于零时的折现率。由于计算口径的不同，基金的内部收益率又分为毛内部收益率和净内部收益率，其中前者通常为计算投资者出资和分配现金流的内部收益率。"
        },
        {
            "title": "股权投资基金管理人应向中国证券投资基金业协会报告的内容包括（　　）。",
            "questions": "I．基金管理人名称、高级管理人员变更<br>II．基金管理人依法解散、被依法撤销或者被依法宣告破产<br>III．基金管理人或高级管理人员存在重大违法违规行为<br>IV．基金管理人分立或者合并",
            "question": "A．I、II、IV\nB．I、II、III\nC．I、II、III、IV\nD．II、III、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于股权投资基金选择第三方基金销售机构（代销机构）进行委托募集，合格代销机构应具备的条件是（　　）。",
            "questions": "I．代销机构是要有代销意愿的基金管理人<br>II．代销机构需遵守募集行为管理办法的规定<br>III．代销机构应具有基金销售资质<br>IV．代销机构需要成为中国证券投资基金业协会会员",
            "question": "A．II、III、IV\nB．I、II\nC．I、II、III\nD．I、II、III、IV",
            "answer": "A",
            "explain": ""
        }, {
            "title": "下列募集资金的行为不属于可能构成非法吸收公众存款罪的是（　　）。",
            "question": "A．向投资者发售虚构的基金\nB．冒充境外某知名企业的代理机构在境内募集资金\nC．以自有房产抵押向亲友借款投资某公司\nD．以不存在的某个项目作为投资标额募集资金",
            "answer": "C",
            "explain": "以自有房产抵押向亲友借款投资某公司不属于可能构成非法吸收公众存款罪的情形。"
        },
        {
            "title": "关于项目跟踪与监控的常用指标，以下属于管理指标的是（　　）。",
            "questions": "I．公司战略与业务定位<br>II．经营风险控制情况<br>III．股东关系与公司治理<br>IV．协议条款执行情况<br>V．拖延付款情况",
            "question": "A．I、II、V\nB．I、II、III、IV\nC．II、III、IV\nD．I、II、III",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "某有限责任公司型股权投资基金有基金投资者A、B、C三人。现投资者C拟通过转让的方式退出基金，说法中正确的是（　　）。",
            "question": "A．投资者A和投资者B不享有优先购买权，由投资者C自主决定转让对象\nB．投资者A和投资者B享有优先购买权,且由A、B双方协商确定购买比例\nC．投资者A和投资者B享有优先购买权,应当按照公司章程的规定确定购买比例\nD．投资者A和投资者B享有优先购买权,且由A、B双方平均行使优先购买权",
            "answer": "C",
            "explain": "有限责任公司有一定的人合性特征，股东之间可以相互转让其持有的股权，但对外转让一般需经其他股东过半数同意，且其他股东有优先受让权，内部多个股东受让时应当按照公司章程确定购买比例。"
        },
        {
            "title": "某股权投资基金的管理人未按时在信息披露备份系统备份基金2018年第三季度以及2019年第一季度的信息披露报告，以下表述错误的是（　　）。",
            "question": "A．该基金管理人的异常情况将通过中国证券投资基金业协会信息公示平台对外公示\nB．该基金管理人整改完毕后，将立即恢复正常机构公示状态\nC．该基金管理人将被中国证券投资基金业协会列入异常机构名单\nD．该基金管理人整改完毕前，中国证券投资基金业协会将暂停受理其基金备案申请",
            "answer": "B",
            "explain": "已登记的基金管理人一旦作为异常机构公示，即使整改完毕，至少6个月后才能恢复正常机构公示状态。故“该基金管理人整改完毕后，将立即恢复正常机构公示状态”错误。"
        },
        {
            "title": "关于基金服务业的利益冲突，以下表述错误的是（　　）。",
            "question": "A．基金服务机构应强化基金服务业务的独立性要求\nB．基金管理人应关注基金服务机构是否存在与提供基金服务相冲突的业务\nC．如果基金服务存在与提供基金服务相冲突的业务，基金管理人应关注基金服务机构是否采取了有效的隔离措施\nD．基金服务机构与基金托管人一定不得为同一机构",
            "answer": "D",
            "explain": "在开展基金服务业务的各个阶段，基金管理人应关注基金服务机构是否存在与提供基金服务相冲突的业务，以及基金服务机构是否采取了有效的隔离措施。同时，基金服务机构也应强化基金服务业务的独立性要求，应采取有效的内控与隔离措施保障基金服务业务独立运营，防范利益冲突。"
        },
        {
            "title": "基金管理人的内部控制要求部门设置体现权责明确、相互制约的原则，不包括（　　）。",
            "question": "A．严格的部门协同制度\nB．严格的岗位分离制度\nC．严格的授权控制\nD．建立完善的信息披露制度",
            "answer": "A",
            "explain": "基金管理人的内部控制要求部门设置体现权责明确、相互制约的原则，包括严格授权控制；建立完善的岗位责任制度和科学、严格的岗位分离制度；严格控制基金财产的财务风险；建立完善的信息披露制度；建立严格的信息技术系统管理制度；强化内部监督稽核和风险管理体系。"
        }, {
            "title": "某合伙型股权投资基金，共有投资者A、B、C三位有限合伙人。投资者C拟将其持有的全部合伙财产份额转让给投资者D，以下表述正确的是（　　）。",
            "questions": "I．不论合伙协议如何约定，该转让事项必须征得投资者A、B的一致同意<br>II．若合伙协议有另行约定，可不必征得投资者A、B的一致同意，以合伙协议约定的条件为准<br>III．投资者A、B不享有优先购买权，投资者C可以自由决定转让给谁<br>IV．除非合伙协议另有约定，投资者A、B享有优先购买权",
            "question": "A．II、III\nB．I、IV\nC．II、IV\nD．I、III",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于股权投资基金的组织形式不包括（　　）。",
            "question": "A．有限合伙型\nB．公司型\nC．契约（信托）型\nD．公私合营型",
            "answer": "D",
            "explain": "根据组织形式不同，股权投资基金可以分为公司型基金、合伙型基金和信托（契约）型基金。"
        },
        {
            "title": "信托（契约）型基金是指通过订立信托契约的形式设立的股权投资基金。关于信托（契约）型基金表述错误的是（　　）。",
            "question": "A．基金是独立法人\nB．基金投资者通过购买基金份额，享有基金投资收益\nC．基金管理人依据法律法规和基金合同负责基金的经营和管理操作\nD．基金的参与主体包括基金投资者、基金管理人及基金托管人",
            "answer": "A",
            "explain": "信托（契约）型基金不具有独立的法人地位。"
        },
        {
            "title": "某目标公司处于早期创业阶段，利润和现金流均为负，当前估值是4亿元，按照创业投资估值法，投资机构估算该公司5年后的股权价值为80亿元，则该投资机构的目标收益率是（　　）。",
            "question": "A．0.82\nB．0.37\nC．0.51\nD．0.1",
            "answer": "A",
            "explain": "当前股权价值=退出时的股权价值/目标回报倍数=退出时的股权价值/(1+目标收益率)^n，设目标收益率为X，那么4=80/(1+X)^5，X=82%。"
        },
        {
            "title": "关于私募基金管理人登记和基金备案，表述错误的是（　　）。",
            "question": "A．私募基金管理人登记证明意味着对私募基金管理人实行牌照管理\nB．私募基金管理人登记证明只是对私募基金管理人履行完登记手续给予事实确认\nC．私募基金登记备案不构成对其投资能力、持续合规情况的认可\nD．私募基金登记备案不作为对基金财产安全的保证",
            "answer": "A",
            "explain": "对股权投资基金管理人和股权投资基金采取登记备案管理，登记备案不是行政许可，无需履行审批程序，登记备案管理是引导、督促行业规范发展，加强事中事后监管，监测行业发展情况及系统性风险的要求。中国证券投资基金业协会根据登记股权投资基金管理人和备案股权投资基金。"
        },
        {
            "title": "股权投资基金A即将开始对目标公司甲的正式尽职调查，通过排他性条款可能规避的风险是（　　）。",
            "question": "A．甲公司高层参股投资参与甲公司有竞争业务的企业\nB．甲公司对公司章程进行修改无需先征得基金A同意\nC．后续融资的公司估值低于基金A计划投资的估值\nD．甲公司CFO同时与多家投资机构进行融资推荐",
            "answer": "D",
            "explain": "排他性条款通常是投资框架协议中的条款，它要求目标公司现任股东及其任何任职职员、董事、财务顾问、经纪人或代表公司行事的人在约定的排他期内不得与其他投资机构进行接触，从而保证双方的时间和经济效率。故“通过排他性条款可能规避的风险是甲公司CFO同时与多家投资机构进行融资推荐”。"
        }, {
            "title": "国家对创业投资企业和天使投资个人在税收上给予特别支持，下列关于天使投资人甲相关税收事项的表述，正确的是（　　）。",
            "question": "A．甲与科技企业签订对赌条款，以可转债的方式投资，约定业绩若不达标则不转为股权，该笔投资仍可享受相关税收政策\nB．甲投资多个初创科技型企业，其中一家已办理注销清算，对其投资额的70%尚未抵扣完的部分，在其后一年内用以抵扣甲转让其他初创科技型企业股权\nC．甲投资了一家初创科技型企业，同时也是这家初创科技企业的发起人，仍可享受相关税收政策\nD．甲按照投资额的70%抵扣转让某初创科技型企业股权取得的应纳税所得额，如果当年不足抵扣的，不能在以后的纳税年度结转抵扣",
            "answer": "B",
            "explain": "天使投资个人在试点地区投资多个初创科技型企业的，对其中办理注销清算的初创科技型企业，天使投资个人对其投资额的70%尚未抵扣完的，可自注销清算之日起36个月内抵扣天使投资个人转让其他初创科技型企业股权取得的应纳税所得额；法人合伙人、个人合伙人可以按照"
        },
        {
            "title": "A基金拟投资X生物科技，在某次尽职调查中A基金考察了X生物科技的融资需求和结构，计划融资的项目，可行性研究报告以及相关批文，此类工作属于（　　）。",
            "question": "A．财务尽职调查\nB．行业尽职调查\nC．业务尽职调查\nD．法律尽职调查",
            "answer": "C",
            "explain": "业务尽职调查包括：企业基本情况、管理团队、融资运用等内容。其中融资运用包括企业融资需求及结构、计划投资项目、可行性研究报告等。故题干中所列工作为业务尽职调查内容。"
        },
        {
            "title": "使用相对估值法进行估值时，得出的计算结果是（　　）。",
            "question": "A．可比公司股权价值\nB．可比公司的估值倍数\nC．目标公司的股权自由现金流\nD．目标公司的企业价值或股权价值",
            "answer": "D",
            "explain": "相对估值法的基本原理是以可以比较的其他公司（可比公司）的价格为基础，来评估目标公司的相应价值。评估所得的价值，可以是股权价值，也可以是企业价值。"
        },
        {
            "title": "基金份额登记机构，提供的服务不包括（　　）。",
            "question": "A．建立并管理投资者的基金账户\nB．办理基金份额认缴、退出\nC．基金交易确认\nD．保管投资者名册",
            "answer": "B",
            "explain": "基金份额登记机构提供的服务包括：建立并管理投资者的基金账户；负责基金份额的登记及资金结算；基金交易确认；代理发放红利；保管投资者名册。"
        },
        {
            "title": "某股权投资基金投资目标公司后，将该公司的核心商业信息透露给其竞争对手企业，可能会被该企业依据（　　）的约定追究责任。",
            "question": "A．排他性条款\nB．保密条款\nC．保护性条款\nD．竞业禁止条款",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于政府引导基金的作用，以下表述正确的是（　　）。",
            "questions": "I．引导并促进新兴产业发展<br>II．支持处于成长期、成熟期或重建期的企业<br>III．吸引社会资本参与，发挥财政资金聚集和放大作用<br>IV．克服单纯通过市场化配置而引发的市场失灵问题",
            "question": "A．I、III、IV\nB．I、II、III\nC．I、IV\nD．II、III、IV",
            "answer": "A",
            "explain": ""
        }, {
            "title": "如果甲合伙企业是乙合伙企业的合伙人之一，则该架构中企业所得税的纳税义务人（　　）。",
            "question": "A．是甲合伙企业\nB．是甲合伙企业和乙合伙企业\nC．既不是甲合伙企业，也不是乙合伙企业\nD．是乙合伙企业",
            "answer": "C",
            "explain": "根据《合伙企业法》等相关规定，合伙企业生产经营所得和其他所得采取“先分后税”的原则：合伙企业以每一个合伙人为纳税义务人，合伙企业层面不缴纳所得税。合伙企业合伙人是自然人的，缴纳个人所得税；合伙人是法人和其他组织的，缴纳企业所得税。如果合伙人本身为合伙企业，则同样按照先分后税的原则，下一层合伙人为纳税义务人。故“该架构中企业所得税的纳税义务人既不是甲合伙企业，也不是乙合伙企业”。"
        },
        {
            "title": "根据现行自律规则的要求，新登记的私募基金管理人在办理登记手续之日起6个月内仍未备案首只基金产品的，中国证券投资基金业协会将（　　）。",
            "question": "A．要求该私募基金管理人做出说明\nB．要求该私募基金管理人提交《法律意见书》\nC．注销该私募基金管理人登记\nD．要求该私募基金管理人出具经审计的财务报表",
            "answer": "C",
            "explain": "基金管理人取得营业执照后，在进行基金的募集前，应当及时向基金业协会进行登记。未经登记，不得进行基金的募集。登记申请材料不完备或不符合规定的，基金管理人应当根据基金业协会的要求及时补正。申请登记期间，登记事项发生重大变化的，基金管理人应当及时告知"
        },
        {
            "title": "创业投资基金A于2012年末投资了初创型企业B，投资总额1000万元，预计5年后退出，预计退出时B公司的估值为8亿元，退出的目标年收益率为50%，根据B公司的业务及资金规划，预计在投资2年后会进行一轮新的融资。2014年末，B公司成功进行了一轮新融资。新投资持有10%的股份。B公司发展顺利，2016年末，B公司实现净利润3000万元，可比公司的市盈率倍数为30。截至2016年末，A基金持有的公司股权估值为（　　）。",
            "question": "A．7551万元\nB．8541万元\nC．7687万元\nD．9495万元",
            "answer": "C",
            "explain": "“创业投资基金A于2012年末投资了初创型企业B，投资总额1000万元，预计5年后退出，预计退出时B公司的估值为8亿元，退出的目标年化收益率为50%”则当前股权价值为8亿除以(1+50%)的5次方，则当前的股权价值为105349794.23868。则A基金投资B公司的初"
        },
        {
            "title": "不违反禁止性规则，可以担任股权投资基金管理人高管人员包括（　　）。",
            "question": "A．因所经营公司逃税被处以有期徒刑，执行期满超过五年\nB．因在证券市场操纵股价被处以措施未满三年\nC．担任破产清算的公司经理，对公司破产负有个人责任的，自该公司破产清算完结之日起已满二年\nD．因涉嫌非法集资正在接受监管机构调查",
            "answer": "A",
            "explain": "通常，管理人、法定代表人或者执行事务合伙人委派代表、董事、监事、高级管理人员最近三年不得因重大违法违规行为受到行业禁入等行政处罚或者刑事处罚，且不存在因涉嫌违法违规行为正在被调查或者正处于整改期间的情形。"
        },
        {
            "title": "股权投资基金募集机构应当向投资者揭示基金风险并安排签署风险揭示书，风险揭示书中的一般风险包括（　　）。",
            "questions": "I．资金损失风险<br>II．流动性风险<br>III．基金运营风险<br>IV．基金委托募集所涉风险",
            "question": "A．I、II、III\nB．II、III、IV\nC．III、IV\nD．I、IV",
            "answer": "A",
            "explain": "股权投资基金募集机构应当向投资者揭示基金风险并安排签署风险揭示书，风险揭示书的内容包括但不限于：（1）股权投资基金的一般风险包括资金损失风险、基金运营风险、流动性风险、募集失败风险、投资标的的风险、税收风险等。（2）股权投资基金的特殊风险包括基金合同与基金业协会合同指引不一致所涉风险、基金未托管所涉风险、基金委托募集所涉风险、外包事项所涉风险、聘请投资顾问所"
        },
        {
            "title": "保密条款约定投融资双方对股权投资交易中所知悉的商业秘密承担保密义务，以下内容通常属于双方商业秘密的是（　　）。",
            "questions": "I．目标公司非公开技术和产品<br>II．目标公司的股东信息<br>III．股权投资基金的投资估值意见<br>IV．股权投资基金非公开的尽职调查方法",
            "question": "A．I、II、III、IV\nB．I、IV\nC．I、III、IV\nD．I、II、III",
            "answer": "C",
            "explain": "保密义务是双方共同的义务。对股权投资基金而言，其在投资过程中知悉的目标公司的非公开的技术、产品、市场、客户、商业计划、财务计划等信息通常均属于商业秘密；对目标公司而言，其在融资过程中所知悉的股权投资基金的非公开的尽职调查方法与流程、投资估值意见、投资框架协议及投资协议条款等信息通常均属于商业秘密。"
        }, {
            "title": "关于境内首次公开发行上市流程中的企业改制，以下表述错误的是（　　）。",
            "question": "A．企业为有限责任公司的，应依法改制为股份有限公司\nB．企业改制阶段企业需要在证券公司（券商）的协助下选定财务顾问\nC．企业改制通常首先需要企业确定证券公司（券商）作为专业机构协助\nD．企业改制上市过程中的中介机构包括会计事务所和律师事务所",
            "answer": "B",
            "explain": "在企业上市流程中，企业改制是指企业以在资本市场公开发行和交易股票为目的而进行的企业组织结构、资本资产等方面的改组行为。企业改制、发行上市牵涉的问题较为广泛和复杂，一般在企业聘请的专业机构的协助下完成。企业首先要确定证券公司(券商)，在券商的协助下尽早选定其他中介机构，主要包括会计师事务所和律师事务所等。在改制阶段，企业为有限责任公司的，应依法改制为股份有限公司并取得营业执照。"
        },
        {
            "title": "关于有限责任公司型股权投资基金的股权转让，除公司章程另有规定外，以下表述正确的是（　　）。",
            "question": "A．股东之间进行股权转让的，应当经其他股东过半数同意\nB．股东不得向股东以外的人转让股权\nC．有限责任公司的股东之间可以相互转让其全部或者部分股权\nD．股东向股东以外的人转让股权的，应当经其他全体股东同意",
            "answer": "C",
            "explain": "有限责任公司型股权投资基金的股权转让，股东之间可以相互转让其持有的股权，但对外转让一般需经过其他股东过半数同意。"
        },
        {
            "title": "根据股权自由现金流折现模型对某公司的股权价值进行估值。估值预测以2年为期，目前为T+0年，公司T+1年的股权自由现金流为2300万元，T+2年的股权自由现金流为2645万元，T+2年之后为后续期，后续期现值为5290万元，若股权要求收益率为15%，则某公司目前股权价值为（　　）万元。(计算结果保留到个位数)",
            "question": "A．9290\nB．4000\nC．5290\nD．8000",
            "answer": "A",
            "explain": "根据题意可得公司目前股权价值=2300万/(1+15%) + 2645万/(1+15%)^2 + 5290万=9290万。"
        },
        {
            "title": "股权投资基金运作期间，基金的费率发生变化，相应信息披露正确的做法是（　　）。",
            "question": "A．无需进行披露\nB．尽快进行临时披露\nC．无需临时披露，只需在半年报或者年报进行披露\nD．基金管理人自主决定披露时间",
            "answer": "B",
            "explain": "在股权投资基金运作期间，当出现与基金管理人或者股权投资基金相关的重大事项时，信息披露义务人应当将重大事项进行临时披露。一般来说，重大事项包括基金管理人和托管人发生重大事项变更、股权投资基金发生重大损失，管理费率或者托管费率变更、清盘或者清算、重大关联交易、提取业绩报酬等。故“股权投资基金运作期间，基金的费率发生变化，相应信息披露正确的做法是尽快进行临时披露”。"
        },
        {
            "title": "股权投资基金管理人、股权基金销售机构在宣传推介过程中的禁止性行为包括（　　）。",
            "questions": "I．向合格投资者之外的单位和个人募集资金<br>II．通过手机短信和微信方式，向不特定对象宣传推介<br>III．不作本金不受损失及固定收益的承诺<br>IV．为投资者提供多人拼凑、资金借贷等满足投资金额的建议或便利",
            "question": "A．I、II、III、IV\nB．I、II、IV\nC．I、III、IV\nD．III、IV",
            "answer": "B",
            "explain": "募集机构不得通过下列媒介渠道推介股权投资基金：(1)公开出版资料 (2)面向社会公众的宣传单、公告、手册、信函、传真 (3)海报、户外广告 (4)电视、电影、电台及其他音像等公共传播媒体 (5)公共网站、门户网站链接广告、博客等 (6)未设置特定对象确定"
        },
        {
            "title": "关于股权投资基金信息披露义务人，表述正确的是（　　）。",
            "question": "A．信息披露义务人委托第三方机构代为披露的，可以免除信息披露义务人的责任\nB．信息披露义务人可以是股权投资基金管理人的风控负责人\nC．同一基金可以存在多个信息披露义务人\nD．信息披露义务人只能是股权投资基金管理人",
            "answer": "C",
            "explain": "同一股权投资基金存在多个信息披露义务人时，应在相关协议中约定信息披露相关事项和责任义务。信息披露义务人委托第三方机构代为披露信息的，不得免除信息披露义务人法定应承担的信息披露义务。信息披露义务人包括股权投资基金管理人、托管人和其他有义务的法人和组织。"
        }, {
            "title": "某企业2016年财报数据中净资产为2000万元，销售收入为1800万元，净利润1200万元，如果以2016年财报数据为基础采用市盈率倍数计算估值，P/E倍数为5时，计算该公司股权价值为（　　）。",
            "question": "A．10000万元\nB．7000万元\nC．9000万元\nD．6000万元",
            "answer": "D",
            "explain": "市盈率倍数=股权价值/净利润，股权价值=净利润x市盈率倍数=1200万x5=6000万元。"
        },
        {
            "title": "股权投资基金募集的一般流程为（　　）。",
            "question": "A．投资者确认—基金路演期—募集筹备期—协议签署及出资\nB．募集筹备期—基金路演期—协议签署及出资—投资者确认\nC．基金路演期—募集筹备期—投资者确认—协议签署及出资\nD．募集筹备期—基金路演期—投资者确认—协议签署及出资",
            "answer": "D",
            "explain": "股权投资基金募集的一般流程主要包括：1、募集筹备期，基金管理人撰写基金私募备忘录，并与可能投资的潜在投资者举行会晤，评估、筛选准备定向路演的对象。2、基金路演期，基金管理人需准备募集推介资料并分发私募备忘录，路演的方式可包括举行线下定向路演活动等。3、投资者确认，基金管理人向达成意向的潜在投资者提供(反向)尽职调查材料，潜在投资者对基金管理人展开(反向)尽职调查。"
        },
        {
            "title": "关于股权投资基金管理人的内部控制，表述正确的是（　　）。",
            "questions": "I．股权基金管理人开展业务外包应制定相应的风险管理框架及制度<br>II．投资决策应符合合同所约定的预期收益、投资范围、投资策略<br>III．所有基金都应当由基金托管人进行托管<br>IV．管理人选择基金服务机构时，应关注该服务机构是否存在与基金服务业务相冲突的其他业务",
            "question": "A．I、II、IV\nB．II、III\nC．I、IV\nD．II、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "股权投资基金的合格投资者应具备相应风险识别能力和风险承担能力，投资于单只股权投资基金的金额至少不能低于人民币（　　）。",
            "question": "A．50万元\nB．100万元\nC．120万元\nD．80万元",
            "answer": "B",
            "explain": "股权投资基金的合格投资者应具备相应风险识别能力和风险承担能力，投资于单只股权投资基金的金额至少不能低于人民币100万元。"
        },
        {
            "title": "股权投资基金监管的重中之重是（　　）。",
            "question": "A．保护基金投资者合法权益\nB．防范系统性金融风险\nC．防止股权投资基金违规操作\nD．加强行业自律",
            "answer": "A",
            "explain": "保护基金投资者合法权益是监管的重中之重，股权投资基金监管必须切实保护基金投资者的合法权益。基金投资者是股权投资基金市场的支持者，只有基金投资者的合法权益得到应有保护，才能鼓励基金投资者把资金投资于股权投资基金行业，股权投资基金行业才能发展。"
        },
        {
            "title": "私募基金管理人申请登记时，中国证券投资基金业协会以（　　）方式，为基金管理人办结登记手续。",
            "question": "A．发放基金管理人登记证书\nB．网站公示\nC．书面回函\nD．邮件回复",
            "answer": "B",
            "explain": "本题考查的是股权投资基金的登记备案。股权投资基金备案材料完备且符合要求的，基金业协会应当自收齐备案材料之日起20个工作日内，以通过网站公示股权投资基金基本情况的方式，为股权投资基金办结备案手续。"
        },
        {
            "title": "相对于证券投资基金，股权投资基金（　　）。",
            "question": "A．期望收益较低\nB．参与管理较少\nC．投资收益波动性较小\nD．流动性较差",
            "answer": "D",
            "explain": "股权投资基金具有投资期限长，流动性差等特点。"
        }, {
            "title": "某股权投资基金以投资当年的预计净利润为基数，按10倍市盈率对目标企业进行投资前估值，基金投资金额为2亿元，投资后持有股权比例为10%，投资当年的预计净利润为（　　）亿元。",
            "question": "A．1.6\nB．1.75\nC．2\nD．1.8",
            "answer": "D",
            "explain": "假设当前年净利润为X。投资金额/(投资前估值+投资额)=10%，2/(10X+2)=10%，X=1.8。"
        },
        {
            "title": "以下信息披露义务人披露基金信息时，不属于禁止性行为的是（　　）。",
            "question": "A．公开披露\nB．向投资者披露投资者账户信息\nC．向投资者承诺承担基金亏损\nD．向投资者预测基金投资收益",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于总收益倍数(TVPI)，说法正确的是（　　）。",
            "question": "A．总收益倍数(TVPI)比已分配收益倍数(DPI)更能反映投资者某一时点的账面回报水平\nB．计算时点越靠后，总收益倍数(TVPI)越大\nC．总收益倍数(TVPI)始终大于已分配收益倍数(DPI)\nD．总收益倍数(TVPI)反映的是投资基金的回收情况",
            "answer": "A",
            "explain": "总收益倍数(TVPI)比已分配收益倍数(DPI)更能反映投资者某一时点的账面回报水平，分配收益倍数(DPI)反映的是投资基金的回收情况，总收益倍数(TVPI)不一定大于已分配收益倍数(DPI)。"
        },
        {
            "title": "关于中国证监会对申请境外直接上市企业的要求，以下表述错误的是（　　）。",
            "question": "A．筹资用途符合国家产业政策、利用外资政策及国家有关固定资产投资立项的规定\nB．过去一年税后利润不少于5000万人民币，并有增长潜力；按照合理市盈率预期，筹资不少于6000万美元\nC．具有规范的法人治理结构及较完善的内部管理制度\nD．净资产不低于4亿元人民币",
            "answer": "B",
            "explain": "过去一年税后利润不少于6000万人民币，并有增长潜力；按照合理市盈率预期，筹资不少于5000万美元。"
        },
        {
            "title": "基金服务机构中的份额登记服务内容不包括（　　）。",
            "question": "A．基金份额登记机构应当保证登记数据的真实、准确、完整\nB．需妥善保管登记数据，保存期限自基金账户销户之日起不得少于20年\nC．基金份额持有人的名称、身份信息及基金份额明细等数据备份至中国证监会认定的机构\nD．定期开展基金会计核算、报表编制等工作",
            "answer": "D",
            "explain": "本题考查的是基金份额登记机构的服务内容。基金份额登记机构的服务内容包括：1、妥善保存登记数据，并将基金份额持有人名称信息及基金份额明细等数据备份至中国证监会认定的机构，其保存期限自基金账户销户之日起不得少于20年。2、基金份额登记机构"
        },
        {
            "title": "股权投资基金募集不得（　　）。",
            "questions": "I．提醒投资者其投资本金可能会发生损失<br>II．提醒投资者其投资收益得不到保证<br>III．向投资者承诺本金不受损失<br>IV．向投资者承诺其投资收益不低于年化3%",
            "question": "A．III、IV\nB．IV\nC．I、II\nD．I、III",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "在对股权投资基金退出收益进行分配时，按分配的时间先后顺序通常为（　　）。",
            "questions": "I．门槛收益<br>II．返还投资成本<br>III．根据“二八模式”按比例分配的超额收益<br>IV．追赶机制下向管理人分配超额收益",
            "question": "A．II、I、IV、III\nB．I、III、IV、II\nC．II、I、III、IV\nD．II、III、I、IV",
            "answer": "A",
            "explain": "基金收益的分配顺序为：返还投资成本，门槛收益，追赶机制下向管理人分配超额收益，根据“二八模式”按比例分配的超额收益。"
        }, {
            "title": "股权投资基金在与目标企业签订排他性条款后，股权投资基金有权（　　）。",
            "question": "A．要求目标企业在与基金谈判过程中，不得在与其他投资机构进行接触\nB．要求目标企业董事、高管和其他关键员工不得兼职与本公司业务有竞争的职位\nC．优先购买目标企业发行的新股或可转换债券\nD．满足事先设定的条件时，可要求目标企业回售股权",
            "answer": "A",
            "explain": "排他性条款通常是投资框架协议中的条款，它要求目标公司现任股东及其任何任职职员、董事、财务顾问、经纪人或代表公司行事的人在约定的排他期内不得与其他投资机构进行接触，从而保证双方的时间和经济效率。"
        },
        {
            "title": "股权投资基金投资阶段的环节包括（　　）。",
            "questions": "I．初步尽职调查<br>II．跟踪与监控<br>III．立项<br>IV．投资交割",
            "question": "A．I、II、IV\nB．II、III、IV\nC．I、III、IV\nD．I、II、III",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于股权投资估值方法，表述错误的是（　　）。",
            "question": "A．私募股权投资基金的估值方法中的乘数法主要使用的可比指标包括：市盈率、市销率、市净率等\nB．私募股权投资基金的估值，通常使用的方法有三类成本法、市场法和收入法\nC．私募股权投资基金的估值方法中的市场法主要包括：有效市场价格法、近期交易价格法、乘数法\nD．私募股权投资基金估值方法中的收入法一般适用于初创型的企业",
            "answer": "D",
            "explain": "收入法是指将投资项目多项未来金额（比如现金流量或收入和支出）换算成一项当前金额（折现）的估值方法。该估值方法一般适用于增长稳定、业务简单、现金流平稳的企业，当具有较高不确定性的企业进行估值预测时，可能会出现较大的偏差。"
        },
        {
            "title": "某股权投资基金2017年度投资收益高，以下违反信息披露禁止性规定的行为包括（　　）。",
            "questions": "I．将基金收益信息发送到仅由全体投资人组成的微信群内<br>II．向投资者披露基金预计不会产生亏损<br>III．将基金管理人内部庆祝照片分享给投资人<br>IV．将基金业绩发布到微信公众号",
            "question": "A．I、II\nB．I、III、IV\nC．II、IV\nD．II、III、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于信托（契约）型股权投资基金的认缴出资和退出，以下表述错误的是（　　）。",
            "question": "A．如有基金托管人进行托管的，基金托管人应当计算认缴出资及退出的价格\nB．基金投资者持有的基金份额全部退出后，即不再是基金份额持有人和基金合同的当事人\nC．认缴出资及退出价格，由基金管理人按照合同约定的规则进行计算\nD．认缴出资是根据基金投资者与基金管理人签订基金合同，承诺认缴金额，并按照基金合同的约定缴纳出资购买基金份额的行为",
            "answer": "A",
            "explain": "本题考查的是信托（契约）型股权投资基金的认缴出资、退出。信托（契约）型股权投资基金的认缴出资，是指基金投资者与基金管理人签订基金合同，承诺认缴金额，并按照基金合同的约定缴纳出资购买基金份额的行为。信托（契约）型股权投资基金的退出，是指在基金成立"
        },
        {
            "title": "关于被投资企业的项目跟踪与监控，下列表述错误的是（　　）。",
            "question": "A．投资机构通常要求被投企业定期提供财务报表和业绩报告\nB．协助建立规范的财务管理体系的目标是改善企业财务状况\nC．投资机构通常会跟踪被投资企业重大合同等业务经营信息\nD．不同类型的被投资企业适用的经营指标不同",
            "answer": "B",
            "explain": "项目跟踪与监控，投资机构与被投资企业的目的都是改善企业经营管理，实现公司股价价值提升，但是双方的发展目标重点有所不同，在企业经营中避免出现企业家的行为与投资机构利益不一致的现象。协助建立规范的财务管理体系的目标是及时发现生产经营中的重大变化，及"
        }, {
            "title": "股权投资基金管理人、托管人及相关服务机构违反法律法规时，中国证监会及其派出机构可以采取行政监管措施、行政处罚等处理方式。以下处理方式中情节最为严重的是（　　）。",
            "question": "A．责令改正\nB．移送司法机关\nC．没收违法所得和没收非法财物\nD．警告",
            "answer": "B",
            "explain": "股权投资基金管理人、托管人及相关服务机构违反法律法规时，中国证监会及其派出机构可以采取行政监管措施、行政处罚等处理方式；构成犯罪的，可以移交司法机关处理。行政监管措施包括：(1)责令改正；(2)监管谈话；(3)出具警示函；(4)公开谴责。行政处罚的种类包括警告、罚款、没收违法所得和没收非法财物、暂停或者撤销基金从业资格等。故“处理方式中情节最为严重的是移送司法机关”。"
        },
        {
            "title": "股权投资基金A计划对某人工智能初创企业B进行投资。B公司处在创业早期，利润和现金流都为负数。根据尽职调查分析结果，B公司预计5年后退出时的估值将达到200亿元，目标年化收益率为60%。最终A基金对B公司投资了1亿元，购入100万股。假设有A基金退出前，B公司又向其他基金以每股50元的价格融资1亿元，若采用加权平均法，A基金于反摊薄条款，采用加权平均法计算应获得的补偿股数最接近（　　）。",
            "question": "A．50万股\nB．100万股\nC．10万股\nD．5万股",
            "answer": "D",
            "explain": "根据加权平均条款计算公式A=Bx(C+D)/(C+E)，B=前轮融资时每股价格为1亿元/100万股=100元，C=新发行前公司总股数=[200亿/(1+60)^5]+100=1907万股，D=没有降价融资时后轮投资者可购买的总股数=100万股，E=降价融资时轮投资者购买的总股数"
        },
        {
            "title": "下列内容中，属于中国证监会对股权投资基金行政监管要求的是（　　）。",
            "questions": "I．要求股权投资基金及其管理人实施登记备案管理<br>II．要求设置合格投资者制度<br>III．不得公开募集基金<br>IV．管理公司组织架构设置",
            "question": "A．I、II、III\nB．II、III、IV\nC．I、II、III、IV\nD．I、II、IV",
            "answer": "A",
            "explain": "《证券法》《证券投资基金法》《私募投资基金监督管理暂行办法》是行政监管的主要法律法规依据，行政监管主要从股权投资基金、股权投资基金管理人、登记备案、合格投资者、资金募集、投资运作、信息披露、服务机构、行业自律等方面进行。同时，对创业投资基金实施"
        },
        {
            "title": "符合股权投资基金管理人主要控制活动要求的做法是（　　）。",
            "questions": "I．管理人为其管理的基金开立募集结算资金专用账户，并接受监督<br>II．除基金合同另有约定外，基金财产应当由基金托管人托管<br>III．委托基金销售机构募集基金时约定基金管理人不再承担募集相关责任<br>IV．根据基金合同所规定的投资目标、投资范围、投资策略等要求进行股权投资决策",
            "question": "A．II、III\nB．I、II、IV\nC．I、II、III\nD．II、IV",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "根据《上市公司创业投资基金股东减持股份的特别规定》(证监会公告[2018]4号)，对专注于长期投资和价值投资的创业投资基金减持其持有的上市公司首次公开发行前的股份给予政策支持，享受该政策的创业投资基金必须符合（　　）。",
            "questions": "I．必须在中国证券投资基金业协会备案<br>II．必须投资于上市企业<br>III．投资方式必须为股权投资或者依法可转换为股权的权益投资<br>IV．对所投企业的股权占比在50%以上",
            "question": "A．I、III\nB．III、IV\nC．I、II\nD．II、III",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "下列各类型股权投资基金中，无须在工商行政管理机关办理工商登记手续的是（　　）。",
            "question": "A．信托（契约）型股权投资基金\nB．股份有限公司型股权投资基金\nC．合伙型股权投资基金\nD．有限责任公司型股权投资基金",
            "answer": "A",
            "explain": "不同于公司型及合伙型股权投资基金，信托（契约）型股权投资基金无须在工商行政管理机关办理工商登记手续。"
        }, {
            "title": "关于已分配收益倍数，以下说法错误的是（　　）。",
            "question": "A．计算已分配收益倍数时，需要考虑当前资产未实现的账面净值\nB．已分配收益倍数体现了投资者的现金回收情况\nC．已分配收益倍数计算结果通常为正数\nD．已分配收益倍数是评价基金业绩的参考指标之一",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "在设计和执行基金管理人内部控制制度时，下列表述正确的是（　　）。",
            "question": "A．重要业务部门和岗位进行物理隔离，增强独立性\nB．将非核心业务外包给中介机构，免除自身责任\nC．设置较多环节，提高控制效果\nD．根据领导要求，灵活执行内部控制制度",
            "answer": "A",
            "explain": "基金管理人应当建立科学、严格的岗位分离制度。明确划分各岗位职责，投资和交易、交易和清算、基金会计和管理人财务核算会计等重要岗位不得有人员的重叠，重要业务部门和岗位应当进行物理隔离。"
        },
        {
            "title": "关于企业境外上市，以下表述错误的是（　　）。",
            "question": "A．境外上市分为境外直接上市和境外间接上市两种方式\nB．境外上市外资股包括H股、B股、N股和S股等\nC．我国企业选择境外直接上市，需要向中国证监会提出申请\nD．境外上市一般包括策划上市方案、准备相关文件、上市申报和公开发行及交易四个步骤",
            "answer": "B",
            "explain": "境外上市分为境外直接上市和境外间接上市两种方式。对接受美元基金投资的境内企业而言，通常采取境外间接上市的方式登陆资本市场。在境外资本市场发行股票并上市，即通常所说的发行H股、N股、S股等。故“境外上市外资股包括H股、B股、N股和S股等”错误。我国企业选择境外直接上市，需要向中国证监会提出申请，境外上市一股包括策划上市方案、准备相关文件、上市申报和公开发行及交易四个步骤。"
        },
        {
            "title": "关于项目退出方式，以下表述错误的是（　　）。",
            "questions": "I．从退出成本的角度来看，相对于首发上市来说，在场外交易市场挂牌所需费用相对较低<br>II．协议转让的退出风险主要表现为由信息不对称所引起的价格不能充分反映被投资企业实际价值的不确定性<br>III．从退出效率的角度来看，一般上市转让退出比协议转让的方式效率高<br>IV．从退出收益的角度来看，一般清算退出的收益较高",
            "question": "A．III、IV\nB．II、III、IV\nC．I、II、III\nD．I、III、IV",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "关于保护性条款，以下表述正确的是（　　）。",
            "question": "A．设立保护性条款的目的是保护目标公司与企业家\nB．保护性条款本质上是一种价格保护机制\nC．设立保护性条款的目的是保护作为大股东的投资者\nD．保护性条款通常针对涉及投资者经济利益或公司控制权的重大事项",
            "answer": "D",
            "explain": "在创业投资中，创业投资基金通常是被投资企业的小股东，因此会向企业家要求设置保护性条款，设立保护性条款的目的是保护作为小股东的投资者，防止其利益受到大股东侵害。故“设立保护性条款的目的是保护目标公司与企业家”和“设立保护性条款的目的是保护作为大股东的投资者”错误。保护性条款针对的通常是涉及投资者经济利益或者公司控制权的重大事项。故“保护性条款本质上是一种价格保护机制”错误。"
        },
        {
            "title": "在下列投资者中，可以成为股权投资基金募集对象的是（　　）。",
            "question": "A．购买了400万股票，过去三年个人年均收入为60万元的刘先生，计划投资于单只股权投资基金的金额不低于100万元\nB．某初涉股权投资领域的A公司，净资产超过3000万元，计划投资于单只股权投资基金的金额不超过50万元\nC．某总资产为1000万元的B公司，计划投资于单只股权投资基金的金额不低于150万元\nD．过去三年年均收入为20万元，名下房屋价值超过1000万元的张女士，计划投资于单只股权投资基金的金额不低于200万元",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "某有限合伙型股权投资基金合伙协议约定管理费自基金成立日起开始计算，年度管理费为投资人总认缴出资的2%，且管理人可以视实际需要预先提取不超过2年的管理费。该基金于7月1日成立，投资人根据合伙协议的约定，在基金成立的当年已按认缴出资的40%实际出资2亿元，则基金成立当年年末，管理人可从基金实际支取的管理费的区间为（　　）。",
            "question": "A．200万元-800万元\nB．200万元-2000万元\nC．500万元-2000万元\nD．500万元-800万元",
            "answer": "C",
            "explain": "总认缴金额=2/40%=5亿元，可支取管理费上限为5x2%x2=0.2亿元，由于自成立之日起至当年年末实际管理时间为半年，则下限为当年应实际支取额5x2%x0.5=0.05亿元。"
        },
        {
            "title": "根据《私募投资基金风险揭示内容与格式指引》，私募基金风险揭示“投资者声明”部分所列的签字页，应当由（　　）逐页签字确认。",
            "question": "A．低风险承受能力的投资人\nB．投资人代表\nC．全体投资人\nD．基金管理人",
            "answer": "C",
            "explain": "股权投资基金管理人自行销售股权投资基金的，应当采取问卷调查等方式，对投资者的风险识别能力和风险承担能力进行评估，由投资者书面承诺符合合格投资者条件；私募基金风险揭示“投资者声明”部分所列的签字页，应当由全体投资者逐页签字确认。"
        },
        {
            "title": "关于折现现金流估值法中的折现率，以下表述错误的是（　　）。",
            "question": "A．企业自由现金流折现模型与股权自由现金流模型中所使用的折现率不同\nB．折现率的选取取决于模型所使用的现金流的性质\nC．股权自由现金流折现模型中，折现率为股权要求收益率\nD．红利折现模型中，折现率为加权平均资本成本",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "基金服务业务是基金管理行业发展到一定阶段的产物。所谓基金服务业务，可以帮助（　　）从繁杂的基金运营管理的业务中解放出来，将基金运作管理过程中部分支持性业务委托给基金服务机构的业务模式。",
            "question": "A．基金管理人\nB．基金监管机构\nC．基金投资者\nD．基金托管人",
            "answer": "A",
            "explain": "基金服务业务可以将基金管理人从繁杂的基金后台运营管理等业务中解放出来，基金管理人可以更好地专注于核心竞争力的提升，从而更好地实现基金行业的专业化分工。"
        },
        {
            "title": "根据基金管理人进行登记与备案所需遵循的原则，以下表述正确的是（　　）。",
            "question": "A．如发生重大事项变更，基金管理人应当在完成工商变更登记后30日内，通过资产管理业务综合报送平台向中国证券投资基金业协会进行重大事项变更\nB．根据信息报送平台的完整性原则，基金管理人申请登记和基金备案时，应保证所填报的信息内容质量，尽可能详尽、具体\nC．基金管理人在办结登记手续起3个月内仍未备案首只基金产品的，则中国证券投资基金业协会将注销该管理人的登记\nD．股权投资基金募集完毕后的20个工作日内，基金管理人应当对所募集的基金进行备案",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "股权投资基金管理人内部控制原则不包括（　　）。",
            "question": "A．相互制约原则\nB．执行有效原则\nC．独立性原则\nD．利益优先原则",
            "answer": "D",
            "explain": "管理人内部控制的原则：全面性原则、相互制约原则、执行有效原则、独立性原则、成本效益原则、适时性原则。"
        },
        {
            "title": "股权回购的发起人通常不包括（　　）。",
            "question": "A．股权投资基金\nB．债权人\nC．股东\nD．管理层",
            "answer": "B",
            "explain": "发起人既可以是股权投资基金，也可以是被投资企业股东、管理层。故“股权回购发起人不包括债权人”。"
        }, {
            "title": "某合伙型股权投资基金包含的基金合同中包含如下条款，其中不符合中国证券投资基金业协会相关合同要求的是（　　）。",
            "question": "A．本基金为有限合伙企业形式，仅含有一名普通合伙人\nB．本基金由普通合伙人兼任执行事务合伙人，执行事务合伙人有权对合伙企业的资产进行投资、管理、运用和处置，并接受其他普通合伙人和有限合伙人的监督\nC．本基金解散清算时首先应对基金合伙人进行分配，如有剩余，则可用于支付基金清算费用\nD．本基金的财产份额不得以任何方式公开募集或发行",
            "answer": "C",
            "explain": "基金财产的清算分配顺序有一定的要求，公司型及合伙型股权投资基金在支付清算费用和职工工资、社会保险费用、法定补偿金以及缴纳所欠税款、清偿债务后的剩余财产，才按基金份额分配给合伙人。"
        },
        {
            "title": "关于非上市企业股份的非公开协议转让，以下表述正确的是（　　）。",
            "question": "A．并股退出、回购退出和清算退出都是协议转让退出的主要方式\nB．除公司章程另有约定外，股份有限公司可以对内部转让股权\nC．员工收购（EBO）是回购退出的一种方式\nD．有限责任公司股权的内部转让，除公司章程另有约定外，需经全部其他股东同意",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于股权投资基金的运作，以下表述正确的是（　　）。",
            "question": "A．采用资本制投资方式下，合伙型股权投资基金精投其他制投资项目具有便利性\nB．股权投资基金的管理人通常参与基金收益的分配\nC．股权投资基金一般可以接受非货币资金出资\nD．通常情况下，基金的投资对象、投资限制由基金管理人决定的",
            "answer": "B",
            "explain": "与一般企业不同，股权投资基金通常要求全部用货币资金出资，一般不接受实物资产、无形资产等非货币资金出资。故“股权投资基金一般可以接受非货币资金出资”错误。在股权投资基金实际运作中，更多地实行承诺出资制度，即投资者承诺向基金出资的总规模，并按合同约定向基金分期出资。"
        },
        {
            "title": "利润和现金流均为负数，未来回报很高，但存在高度不确定性的早期项目一般采用的估值方法是（　　）。",
            "question": "A．市销率法\nB．退出时股权价值/目标回报倍数倒推法\nC．企业价值/股权价值折现法\nD．市现现金流估值法",
            "answer": "B",
            "explain": "如果股权投资基金拟投资的目标公司处于创业早期，利润和现金流均为负数，未来回报很高，但存在高度不确定性，此时，往往会用创业投资估值法。创业投资估值法通过评估目标公司退出时的股权价值，再基于目标回报倍数或收益率，倒推出目标公司的当前价值。"
        },
        {
            "title": "关于中小企业的融资需求特征，以下表述错误的是（　　）。",
            "question": "A．科技型企业在形成产业化能力之前，研发投入形成的固定资产在其资产结构中占有较高比例\nB．部分中小型企业不建立规范的公司治理制度，其投资人获取真实信息的难度较高\nC．企业在各个创业阶段，其融资需求的性质和规模呈现出较为明显的区别\nD．中小微企业创业成功的不确定性较高，仅少数创业企业能获得巨大的成功",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "股权投资基金投资企业间接上市的方式包括（　　）。",
            "questions": "I．上市公司重大资产重组<br>II．全国中小企业股份转让系统挂牌<br>III．借壳上市<br>IV．区域性股权交易市场挂牌",
            "question": "A．II、IV\nB．I、II\nC．I、III\nD．III、IV",
            "answer": "C",
            "explain": "所投资企业除了股票首次公开发行并上市外，还可以通过参与上市公司重大资产重组或借壳上市等方式间接上市，间接上市成功的，股权投资基金持有的被投资企业股份（股权）也可以转变为相关上市公司的股份，通过公开市场转让，实现退出。"
        },
        {
            "title": "甲公司注册在A地，投资B地的公司型基金乙和合伙型基金内，其中A地和B地投资类企业所得税率均为25%。基金乙和基金丙在某年均向甲公司分配投资收益1,000万元，不考虑其他财税因素，甲公司就该两笔收益应向A地缴纳所得税（　　）。",
            "question": "A．250万元\nB．500万元\nC．0元\nD．750万元",
            "answer": "A",
            "explain": "公司型基金的税收规则是“先税后分”。对公司型基金而言，“转让财产收入”“股息、红利等权益性投资收益”为主要收入来源，其中“转让财产收入”即公司型基金转让标的企业股权获得的收入。当以债转股等方式投资时，还可能存在“利息收入”。三类收入中"
        }, {
            "title": "下列行为中，应被认定为我国刑法第179条规定的擅自发行股票、公司、企业债券的是（　　）。",
            "questions": "I．某股权众筹平台通过转让股权的方式，累计向其100名实名注册会员进行融资<br>II．未经依法核准擅自发行基金份额募集基金，情节严重的<br>III．明知他人从事擅自发行股票、债券等犯罪活动，仍为其提供广告等宣传<br>IV．未经有关部门批准，向社会不特定对象以转让股权等方式变相发行股票",
            "question": "A．III、IV\nB．I、II、III\nC．II、IV\nD．I、II、III、IV",
            "answer": "A",
            "explain": "依据《刑法》第一百七十九条的规定，未经国家有关主管部门批准，擅自发行股票或者公司、企业债券，数额巨大、后果严重或者有其他严重情节的，构成擅自发行股票、公司、企业债券罪。按《最高人民法院关于审理非法集资刑事案件具体应用法律若干问题的解释》第六条"
        },
        {
            "title": "杠杆收购的主要资金来源中，由杠杆收购基金提供的是（　　）。",
            "question": "A．垃圾债券\nB．优先股\nC．股权资本\nD．银行贷款",
            "answer": "C",
            "explain": "杠杆收购的收购资金主要有三个来源。第一，普通股，由收购方提供资金。股权资本主要由杠杆收购基金提供，采取普通股的形式。第二，夹层资本，一般采取优先股和垃圾债券的形式，有时附有转股权。第三，高级债，即银行提供的并购贷款。故“杠杆收购的主要资金来源中，由杠杆收购基金提供的是股权资本”。"
        },
        {
            "title": "关于不同组织形式的基金，以下表述正确的是（　　）。",
            "question": "A．信托(契约)型基金需要在工商登记机关申请设立法律实体\nB．公司型基金委托给其他基金管理人管理，基金股东无须再承担责任\nC．公司型基金相对合伙型和信托(契约)型基金有更成熟的法律环境，通常可以有效降低风险\nD．合伙型基金是非法人企业，所有合伙人要承担无限连带责任",
            "answer": "C",
            "explain": "公司型基金主要有以下特点：第一，公司在很多国家比合伙企业、契约结构有着更悠久的历史和更为健全的法律环境，进而使这些国家的公司有着更完整的组织结构和更规范的管理系统，可以有效降低运作风险。"
        },
        {
            "title": "某有限责任公司型基金有50名股东，其中一名股东拟对外转让股权，下述可以接受转让的对象是（　　）。",
            "question": "A．未备案的一只信托(契约)型基金\nB．未备案的一家合伙企业\nC．一家保险公司\nD．两名自然人",
            "answer": "C",
            "explain": "股权投资基金应当向合格投资者募集。单只股权投资基金的投资者人数累计不得超过《证券投资基金法》《公司法》《合伙企业法》等法律规定的特定数量，即有限责任公司型和有限合伙型股权投资基金投资者人数不超过50人，股份有限公司型和信托(契约)型股权投资基金投资者人数不超过200人。"
        },
        {
            "title": "关于股权投资基金信息披露内容，以下表述错误的是（　　）。",
            "question": "A．信息披露义务人必须向投资者充分揭示基金运作相关的风险\nB．必须确保对所有基金持有人进行全面披露，不得只向特定对象进行局部披露\nC．披露信息必须客观事实，信息不得经过扭曲或粉饰\nD．基金信息披露可以自主判断，选择基金投资者有利的事项披露",
            "answer": "D",
            "explain": "基金信息披露不可以自主判断，选择基金投资者有利的事项披露。"
        },
        {
            "title": "股权投资基金所投企业，适合采用收入法进行估值的是（　　）。",
            "question": "A．增长不稳定、业务简单、现金流平稳\nB．增长稳定、业务简单、现金流平稳\nC．增长不稳定、业务复杂、现金流波动\nD．增长稳定、业务简单、现金流波动",
            "answer": "B",
            "explain": "收入法是指将投资项目多项未来金额（比如现金流量或收入和支出）换算成一项当前金额（折现）的估值方法。使用收入法进行估值时，通常需要对预测期间投资项目的发展计划、盈利能力、财务状况等进行详细的分析。该估值方法一般适用于增长稳定、业务简单、现金流平稳的企业，当对具有较高不确定性的企业进行估值预测时，可能会出现较大的偏差。"
        }, {
            "title": "股权投资基金A，股权投资基金B分别持有目标公司甲的股权10%及15%，其余股份均为创始人持有。目标公司甲拟通过500股融资1000万元用于扩展线下直营店。股权投资基金C有意向认购，创始人及股权投资基金B表示放弃优先认购权，股权投资基金A行使优先认购权，则股权投资基金C可以认购的股份数量以及对应的投资额分别为（　　）。",
            "question": "A．400股；800万元\nB．225股；450万元\nC．375股；750万元\nD．450股；900万元",
            "answer": "D",
            "explain": "优先认购权是指目标公司未来发行新的股份或者可转换债券时，股权投资基金将按其持股比例获得同等条件下的优先认购权利。本题中，A行使优先认购权，则可认购50股100万金额的股权。创始人和B放弃认购，则C可以认购的股份数量以及对应的投资额分别为450股900万金。"
        },
        {
            "title": "某目标公司A的创始股东持股数量为50000股，前轮投资者A基金以每股1.6元的价格购买了10000股，后轮投资者B基金以每股1元的价格购买了10000股。在完全棘轮条款下，创始股东需向A基金补偿的股票数量为（　　）股。",
            "question": "A．80000\nB．8000\nC．10000\nD．6000",
            "answer": "D",
            "explain": "适用完全棘轮条款时，前轮投资者过去投入的资金所换取的股权全部按新的最低的价格重新计算，完全棘轮的特点在于不考虑下一轮新发行股权的数量，只是简单地对比后轮融资与前轮融资的价格差异。本题中首先计算出前轮投资者投入的资金，1.6×10000=16000，接着计算在降价之后可以购买的股数，16000-1=16000股，最后算出需向A基金补偿的股票数量16000-10000=6000股。"
        },
        {
            "title": "某目标公司A的创始股东持股数量为5000股，前轮投资者A基金以每股1.6元的价格购买了10000股，后轮投资者B基金以每股1元的价格购买了10000股。在完全棘轮条款下，创始股东需向A基金补偿的股票数量为（　　）股。",
            "question": "A．80000\nB．8000\nC．10000\nD．6000",
            "answer": "D",
            "explain": "适用完全棘轮条款时，前轮投资者过去投入的资金所换取的股权全部按新的最低的价格重新计算，完全棘轮的特点在于不考虑下一轮新发行股权的数量，只是简单地对比后轮融资与前轮融资的价格差异。本题中首先计算出前轮投资者投入的资金，1.6×10000=16000，接着计算在降价之后可以购买的股数，16000-1=16000股，最后算出需向A基金补偿的股票数量16000-10000=6000股。"
        },
        {
            "title": "关于股权投资基金的收益分配，以下表述正确的是（　　）。",
            "question": "A．股权投资基金从事的是长期投资,且透明性好、收益性高,故基金管理人通常参与基金收益的分配\nB．无论有无相关规定，基金管理人必须先让基金投资者实现门槛收益后才可以获得业绩报酬\nC．收益分配主要在基金的投资者、管理人和第三方服务机构进行\nD．基金的收益来源之一是投资企业分配的红利",
            "answer": "D",
            "explain": "股权投资基金透明度不高，基金收益分配可以不设定门槛收益率，第三方服务机构不参与基金收益分配。"
        },
        {
            "title": "关于项目退出，以下表述错误的是（　　）。",
            "questions": "I．股权投资基金应根据被投资企业的发展情况、市场情况和股权投资基金自身的运营情况等及时调整退出方式<br>II．从退出风险的角度来看上市转让退出的风险主要表现在企业上市申请是否获批的不确定性和锁定期内的股票价格波动<br>III．股权投资基金投资目标企业的根本目的是获取控制企业的经营权和管理权,以此来控制投资风险<br>IV．清算退出的项目退出风险主要表现为由信息不对称所引起的价格不能充分反映被投资企业实际价值的不确定性",
            "question": "A．II、IV\nB．III、IV\nC．I、III、IV\nD．II、III",
            "answer": "B",
            "explain": "股权投资基金投资目标企业的根本目的是实现企业价值增值，并不是控制企业的经营权和管理权。协议转让的风险主要表现为由信息不对称所引起的价格不能充分反映被投资企业实际价值的不确定性。"
        },
        {
            "title": "某有限责任公司型股权投资基金近期拟完成第二次募集关账，其中新投资人甲拟投资500万元，同时原股东乙拟转让400万元给外同时减少出资一百万元。以下表述错误的是（　　）。",
            "question": "A．本次增资或减资决议需要经过代表1/2以上表决权的股东通过\nB．甲出资将增加公司注册资本金\nC．乙向丙转让需要一定比例其他股东同意\nD．工商变更完成后，基金规模增加四百万元",
            "answer": "A",
            "explain": "有限责任公司型股权投资基金作出增资或者减资决议，必须经代表2/3以上表决权的股东通过。"
        }, {
            "title": "并购基金投资标的特点不包括（　　）。",
            "question": "A．更加倾向于价值被低估的企业\nB．优先投资科技型初创企业\nC．比较偏向于已形成一定规模和产生稳定现金流的成熟企业\nD．优先寻找拥有先进技术但运营质量较差的企业",
            "answer": "B",
            "explain": "并购基金的每一笔投资都有其独特性，但其同点是都通过财务杠杆来完成对目标企业的收购。高杠杆的融资结构对目标企业的资产及现金流创造能力提出了要求，优质的资产提高了收购方获得债务融资的可能，充裕的现金流增强了收购方偿付债务的能力，同时具备这两个条件的企业自然成为杠杆收购基金的理想投资对象。具体来说，杠杆收购基金的投资对象通常具有以下特征：处于成熟行业；强劲、稳固的市场地位；稳定、可预测的现金流；拥有坚实的抵押资产基础；资产负债率较低；资本性支出较低；有减少开支的潜力；资产可剥离。故并购基金投资标的特点不包括“优先投资科技型初创企业”。"
        },
        {
            "title": "某企业的股权资本成本为12%，税前债务成本为10%，权益在资本占比结构中为60%，负债在资本占比结构中为40%，假定所得税税率为25%，则该企业的加权平均资本成本（WACC）为（　　）。",
            "question": "A．0.102\nB．0.111\nC．0.1\nD．0.112",
            "answer": "A",
            "explain": "加权平均资本（WACC）是企业各种融资来源的资本成本的加权平均值，计算公式为：WACC=D/(D+E) xKd x (1-t) +E/(D+E) xKe。其中D为付息债务的市场价值，E为股权的市场价值，Kd为税前债务成本，Ke为股权资本成本，t为所得税税率。代入公式，WACC=60%x12%+40%x(1-25%)x10%=10.2%。"
        },
        {
            "title": "其他条件不变，以下引起基金资产净值（NAV）增加的选项是（　　）。",
            "question": "A．基金应承担的管理费的增加\nB．基金货币资金的减少\nC．基金应承担的负债的增加\nD．基金已投项目的公允价值的增加",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "股权投资基金募集流程通常不包括（　　）。",
            "question": "A．基金路演\nB．投资者确认\nC．协议签署及出资\nD．储备项目收集",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "股权投资基金的机构类合格投资者必须具备相应风险识别能力和风险承担能力，且（　　）。",
            "question": "A．净资产不低于1000万元\nB．总资产不低于3000万元\nC．总资产不低于1000万元\nD．净资产不低于3000万元",
            "answer": "A",
            "explain": ""
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/11/smgq-1.js